/* Bannor Toys – free ornament personalization box (added Oct 2026)
   Shows a text box under the free ornament in the cart and saves what the
   customer types onto the ornament line item ("Ornament personalization"),
   so it appears on the order line in Shopify, ShipStation and packing slips.
   Also saves the order note as it's typed so a cart redraw can't wipe it. */
(function () {
  var HANDLE = 'free-personalized-ornament-2026';
  var PROP = 'Ornament personalization';
  var MAX_WORDS = 10;
  var timer = null;
  var pendingInput = null;
  var busy = false;

  function words(v) { return v.trim().split(/\s+/).filter(Boolean); }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function save(input) {
    var status = input.parentNode.querySelector('[data-orn-status]');
    var w = words(input.value);
    if (w.length > MAX_WORDS) {
      input.value = w.slice(0, MAX_WORDS).join(' ');
      if (status) status.textContent = 'Up to 10 words, so we trimmed the extra.';
    }
    var value = input.value.trim();
    var key = input.getAttribute('data-line-key');
    if (status && w.length <= MAX_WORDS) status.textContent = 'Saving...';
    busy = true;
    return getCart().then(function (cart) {
      var item = cart.items.filter(function (i) { return i.key === key; })[0] ||
                 cart.items.filter(function (i) { return i.handle === HANDLE; })[0];
      if (!item) { busy = false; return; }
      if ((item.properties || {})[PROP] === value) {
        busy = false;
        if (status) status.textContent = value ? 'Saved ✓' : '';
        return;
      }
      var props = {};
      var old = item.properties || {};
      for (var k in old) { if (Object.prototype.hasOwnProperty.call(old, k) && old[k] != null) props[k] = old[k]; }
      props[PROP] = value;
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
      }).then(function (r) { return r.json(); }).then(function (newCart) {
        var updated = (newCart.items || []).filter(function (i) { return i.handle === HANDLE; })[0];
        if (updated) {
          input.setAttribute('data-line-key', updated.key);
          var row = input.closest('[data-item]');
          if (row) {
            row.setAttribute('data-item', updated.key);
            var els = row.querySelectorAll('[data-id]');
            for (var j = 0; j < els.length; j++) els[j].setAttribute('data-id', updated.key);
          }
        }
        busy = false;
        if (status) status.textContent = value ? 'Saved ✓' : '';
      });
    }).catch(function () {
      busy = false;
      if (status) status.textContent = 'Could not save, please try again.';
    });
  }

  function buildBox(item) {
    var wrap = document.createElement('div');
    wrap.className = 'orn-personalization';
    wrap.setAttribute('data-orn-box', '');
    wrap.style.cssText = 'width:100%;box-sizing:border-box;margin:10px 0 4px;padding:8px 10px;border:2px dashed #93C8BE;border-radius:10px;background:#f6fbfa;';
    var id = 'orn-' + Math.random().toString(36).slice(2, 8);
    wrap.innerHTML =
      '<label for="' + id + '" style="display:block;font-weight:700;font-size:13px;margin-bottom:4px;">' +
      'Ornament personalization (up to 10 words)</label>' +
      '<input type="text" id="' + id + '" data-orn-input autocomplete="off" maxlength="90" ' +
      'placeholder="Leave blank for no personalization" ' +
      'style="width:100%;min-width:0;box-sizing:border-box;padding:7px 8px;border:1px solid #ccc;border-radius:6px;font-size:13px;">' +
      '<small data-orn-status style="display:block;font-size:12px;margin-top:4px;opacity:.85;"></small>';
    var input = wrap.querySelector('input');
    input.setAttribute('data-line-key', item.key);
    input.value = (item.properties || {})[PROP] || '';
    return wrap;
  }

  function decorate() {
    if (busy) return;
    var all = document.querySelectorAll('.cart__item[data-item]');
    var rows = [];
    for (var a = 0; a < all.length; a++) {
      if (all[a].querySelector('a[href*="/products/' + HANDLE + '"]') && !all[a].querySelector('[data-orn-box]')) rows.push(all[a]);
    }
    if (!rows.length) return; // nothing to add: no cart request made
    getCart().then(function (cart) {
      var orn = cart.items.filter(function (i) { return i.handle === HANDLE; })[0];
      if (!orn) return;
      for (var r = 0; r < rows.length; r++) {
        var row = rows[r];
        var isOrn = row.getAttribute('data-item') === orn.key ||
          (row.querySelector('a[href*="/products/' + HANDLE + '"]') !== null);
        if (!isOrn || row.querySelector('[data-orn-box]')) continue;
        var anchor = row.querySelector('.cart__item__meta') || row.querySelector('.cart__item__content-inner');
        if (anchor) anchor.parentNode.insertBefore(buildBox(orn), anchor.nextSibling);
      }
    });
  }

  // Order note: save to the cart as the customer types, so a cart redraw
  // (quantity change, free gift auto-added) can't wipe it before checkout.
  var noteTimer = null;
  function saveNote(el) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ note: el.value })
    }).catch(function () {});
  }
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('textarea[name="note"]')) return;
    clearTimeout(noteTimer);
    var el = e.target;
    noteTimer = setTimeout(function () { saveNote(el); }, 700);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('textarea[name="note"]')) return;
    clearTimeout(noteTimer);
    saveNote(e.target);
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-orn-input]')) return;
    clearTimeout(timer);
    pendingInput = e.target;
    timer = setTimeout(function () { var t = pendingInput; pendingInput = null; if (t) save(t); }, 800);
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-orn-input]')) return;
    clearTimeout(timer);
    pendingInput = null;
    save(e.target);
  });

  // Make sure a just-typed personalization is saved before going to checkout.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[name="checkout"], a[href="/checkout"], .cart__checkout');
    if (!btn || !pendingInput) return;
    e.preventDefault();
    e.stopPropagation();
    clearTimeout(timer);
    var t = pendingInput;
    pendingInput = null;
    save(t).then(function () { btn.click(); });
  }, true);

  var debounce = null;
  var obs = new MutationObserver(function () {
    clearTimeout(debounce);
    debounce = setTimeout(decorate, 250);
  });
  function start() {
    obs.observe(document.body, { childList: true, subtree: true });
    decorate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
